// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__pnqAz","title":"AfterFrontImage_title__12Z9l"};